import { logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";
import request from "@/utils/request";

function getPrem(productId, token, commit) {
  request
    .get(`/common/unAuth/checkUserPerm/${token}/${productId}`)
    .then((res) => {
      if (res.data.hasPerm) {
        commit("SET_USERPREM", productId);
      }
    });
}

const getDefaultState = () => {
  return {
    userId: "",
    userName: "",
    avatar: "",
    prem: [],
    selectCountry: "",
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_USERID: (state, userId) => {
    state.userId = userId;
  },
  SET_NAME: (state, name) => {
    state.userName = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_USERPREM: (state, prem) => {
    state.prem.push(prem);
  },
  SET_SELECTCOUNTRY: (state, selectCountry) => {
    state.selectCountry = selectCountry;
  },
};

let userInfo = {
  userId: "",
  userName: "",
  loginId: "",
  userTypeId: 0,
  isAdv: 0,
  intercurrentNunm: 0,
};

const actions = {
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((response) => {
          const { data } = response;
          try {
            let jsonData = JSON.parse(data);
            if (jsonData.code !== 0) {
              removeToken();
              commit("SET_USERID", "");
              sessionStorage.removeItem("Authorization");
              resolve(userInfo);
            } else {
              userInfo = jsonData.data;
              const { userName, userId } = userInfo;
              commit("SET_NAME", userName);
              commit("SET_USERID", userId);
              sessionStorage.setItem("Authorization", getToken());
              getPrem(0, getToken(), commit);
              // getPrem(2575, getToken(), commit)
              resolve(userInfo);
            }
          } catch (e) {
            removeToken();
            commit("SET_USERID", "");
            sessionStorage.removeItem("Authorization");
            resolve(userInfo);
          }
        })
        .catch((error) => {
          removeToken();
          commit("SET_USERID", "");
          sessionStorage.removeItem("Authorization");
          resolve(userInfo);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          resetRouter();
          commit("RESET_STATE");
          sessionStorage.removeItem("Authorization");
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      sessionStorage.removeItem("Authorization");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
